// extracted by mini-css-extract-plugin
module.exports = {"mobileToolbarHolder":"MobileToolbar_mobileToolbarHolder__vAtPz","mobileToolbarButtonsHolder":"MobileToolbar_mobileToolbarButtonsHolder__2ph_U"};